import { render, staticRenderFns } from "./upload-ifc-federated.vue?vue&type=template&id=c841dbca&scoped=true"
import script from "./upload-ifc-federated.vue?vue&type=script&lang=js"
export * from "./upload-ifc-federated.vue?vue&type=script&lang=js"
import style0 from "./upload-ifc-federated.vue?vue&type=style&index=0&id=c841dbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c841dbca",
  null
  
)

export default component.exports